import { createFileRoute } from "@tanstack/react-router"

// Route-depth MARKER: `/channels/internal` is the INTERNAL (staff-only) audience
// segment. The Channels LAYOUT route (channels.tsx) derives `audience` from the
// matched route id and filters the list to staff-only channels.
export const Route = createFileRoute("/$orgSlug/$eventSlug/channels/internal")({
  component: () => null,
})
